import { useState } from 'react'
import { Box } from '@mui/material'
import { Card } from 'packages/eid-ui'
import { usePageContext } from 'pageContext'
import { useTranslation } from 'react-i18next'
import GenericFilter from '../EidFilter/GenericFilter'
import { useInboxItemStatues } from 'hooks'

const InboxItemStatusFilter = () => {
    const { t } = useTranslation()
    const [state] = usePageContext()
    const [enableApiCall, setEnableApiCall] = useState(false)
    const { data: statusData } = useInboxItemStatues(enableApiCall)

    return (
        <Card
            cardTitle={t('Status')}
            collapsible
            expanded={Boolean(state.inboxItemStatus)}
            onExpandChange={(expanded) => setEnableApiCall(expanded)}
        >
            <Box
                padding="0"
                style={{
                    borderTop: 'solid 1px #efeff1',
                    backgroundColor: '#fbfbfd',
                }}
            >
                <Box padding="20px 20px 0px 20px">
                    <GenericFilter
                        type="checklist"
                        searchable={false}
                        staticData={statusData?.map(status => ({
                            id: status.rtA_CSVInboxItemStatusID,
                            friendlyName: status.name,
                            ...status
                        }))}
                        contextProp="inboxItemStatus"
                        selectedValueIndicatorProp="id"
                        state={state}
                        showPagination={false}
                    />
                </Box>
            </Box>
        </Card>
    )
}

export default InboxItemStatusFilter
